import request from '@/utils/request'

// 管理员登录
export function login(data) {
  return request({
    url: '/admin/api/auth/login',
    method: 'post',
    data
  })
}

// 获取管理员信息
export function getProfile() {
  return request({
    url: '/admin/api/auth/profile',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/admin/api/auth/change-password',
    method: 'put',
    data
  })
}

// 管理员退出登录
export function logout() {
  return request({
    url: '/admin/api/auth/logout',
    method: 'post'
  })
}